import script from "./UnlinkCurvedIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./UnlinkCurvedIcon.vue?vue&type=script&setup=true&lang=js"

export default script